import { useCallback, useState } from 'react';
import type { CommonScheduleResponse, DialInData } from '../../../types';
import { CALENDAR_TYPE_OTHER } from '../../ScheduleMeetingModal/helpers/constants';
import type {
  CreatedCalendarEvent,
  ScheduleMeetingSuccessPayload,
} from '../../ScheduleMeetingModal/types/hooks';

interface ScheduleMeetingInviteState {
  meetingCard: CommonScheduleResponse | undefined;
  dialInData: DialInData | undefined;
  showInvite: boolean;
  isOtherCalendarInvite: boolean;
  createdCalendarEvent: CreatedCalendarEvent | undefined;
  handleSuccess(payload: ScheduleMeetingSuccessPayload): void;
  closeInvite(): void;
}

function useScheduleMeetingInvite(): ScheduleMeetingInviteState {
  const [meetingCard, setMeetingCard] = useState<CommonScheduleResponse>();
  const [dialInData, setDialInData] = useState<DialInData>();
  const [showInvite, setShowInvite] = useState(false);
  const [isOtherCalendarInvite, setIsOtherCalendarInvite] = useState(false);
  const [createdCalendarEvent, setCreatedCalendarEvent] = useState<CreatedCalendarEvent>();

  const handleSuccess = useCallback((payload: ScheduleMeetingSuccessPayload) => {
    setMeetingCard(payload.meeting);
    setDialInData(payload.dialIn);
    setCreatedCalendarEvent(payload.createdCalendarEvent);
    setIsOtherCalendarInvite(payload.calendarOption === CALENDAR_TYPE_OTHER);
    setShowInvite(true);
  }, []);

  const closeInvite = useCallback(() => {
    setShowInvite(false);
    setDialInData(undefined);
    window.dispatchEvent(
      new CustomEvent('calendar-meeting-scheduled', {
        detail: { meetingCard, createdCalendarEvent },
      }),
    );
    setCreatedCalendarEvent(undefined);
  }, [meetingCard, createdCalendarEvent]);

  return {
    meetingCard,
    dialInData,
    showInvite,
    isOtherCalendarInvite,
    createdCalendarEvent,
    handleSuccess,
    closeInvite,
  };
}

export default useScheduleMeetingInvite;
